import { type CommandHandler } from '@telespot/core';

import { DeprecateAlgorithm } from './deprecate-algorithm.command';
import { Algorithm, type AlgorithmRepository } from '@telespot/domain';

/**
 * @group Protocols
 * @category Errors
 */
export class DeprecateAlgorithmError extends Error {
  constructor(public readonly algorithmId: string) {
    super(`Deprecation error: algorithm not found with id ${algorithmId}`);
  }
}

export type IDeprecateAlgorithmHandler = CommandHandler<DeprecateAlgorithm>;

/**
 * @group Protocols
 * @category Handlers
 */
export class DeprecateAlgorithmHandler implements IDeprecateAlgorithmHandler {
  constructor(private readonly algorithmRepository: AlgorithmRepository) {}

  private async getAlgorithm(algorithmId: string): Promise<Algorithm> {
    try {
      return await this.algorithmRepository.getById(algorithmId);
    } catch (error) {
      throw new DeprecateAlgorithmError(algorithmId);
    }
  }

  async execute(command: DeprecateAlgorithm): Promise<void> {
    const { algorithmId, deprecate } = command.details;

    // Check if the algorithm exists
    const algorithm = await this.getAlgorithm(algorithmId);

    // Change the deprecation status of the algorithm
    algorithm.changeDeprecationStatus(deprecate ?? true);
    await this.algorithmRepository.saveAlgorithm(algorithm);
  }
}
